<template>
    <b-card>
        <div class="card-body">

            <file-upload
                title="Upload het Locus bestand het aantal bestelde presales per winkel"
                url="/api/rest/locations/batch-generate-store-presale-labels"
                :instructions="instructions"
                :formFields="formFields"
                accept=".xlsx,.xls"
                @success="onUploadSuccess"
                @error="onUploadError"
                @reset="onReset"
            ></file-upload>

            <b-alert v-if="uploadStatus === 'success'" show variant="success" class="mt-4">
                <h4 class="instructions-title">
                    <font-awesome-icon icon="check-circle"/>
                    Bestand {{ this.file.name }} is succesvol geüpload en verwerkt
                </h4>
                <ul><li>{{uploadMessage}}</li></ul>
            </b-alert>

            <b-alert v-if="uploadStatus === 'error'" show variant="danger" class="mt-4">
                <h4 class="instructions-title">
                    <font-awesome-icon icon="times-circle"/>
                    Bestand {{ this.file.name }} is niet verwerkt
                </h4>
                <ul>
                    <li v-for="(error, index) in errors" :key="index">{{error.message}}</li>
                </ul>
            </b-alert>

        </div>
    </b-card>
</template>

<script>

import FileUpload from "@/components/FileUpload.vue";

export default {
    name: "PresaleStoreLabels",
    components: {FileUpload},
    data() {
        return {
            formFields: [
                { title: "Product nummer", name: "product_identifier", value: "", placeholder: "Vul een volledig productnummer in" },
                { title: "Prijs per stuk", name: "unit_gross_price", value: "", placeholder: "Vul de stukprijs in"  },
            ],
            instructions: [
                'Het bestand bevat de kolommen "Afnemer", "Artikelnr." en "Besteld"',
                'Alleen voor het ingevulde product nummer worden de labels geprint.'
            ],
            uploadStatus: "",
            uploadMessage: "",
            file: "",
            errors: [],
        }
    },
    methods: {
        onUploadSuccess(file, response) {
            this.uploadStatus = "success"
            this.file = file
            this.uploadMessage = "Er zijn " + response.data.tracking_urls.length + " print opdrachten verstuurd"
        },
        onUploadError(file, exception) {
            this.uploadStatus = "error"
            this.file = file
            this.errors = exception.response.data.errors
        },
        onReset() {
            this.uploadMessage = ""
            this.uploadStatus = ""
        },
    }
};
</script>

<style scoped>

.instructions-title {
    font-size: 1rem;
}

</style>